(() => {
  const STORAGE_KEY = 'mrCompareProducts';
  const MAX_PRODUCTS = 4;

  function getProducts() {
    try {
      const products = JSON.parse(
        localStorage.getItem(STORAGE_KEY)
      );

      return Array.isArray(products)
        ? products.slice(0, MAX_PRODUCTS)
        : [];
    } catch (error) {
      return [];
    }
  }

  function saveProducts(products) {
    localStorage.setItem(
      STORAGE_KEY,
      JSON.stringify(products.slice(0, MAX_PRODUCTS))
    );
  }

  function formatPrice(cents, currency) {
    const value = Number(cents) / 100;

    try {
      return new Intl.NumberFormat('de-DE', {
        style: 'currency',
        currency: currency || 'EUR'
      }).format(value);
    } catch (error) {
      return `${value.toFixed(2).replace('.', ',')} €`;
    }
  }

  function getCurrentProduct() {
    const element = document.querySelector(
      '[data-mr-compare-product]'
    );

    if (!element) return null;

    return {
      id: element.dataset.productId,
      variantId: element.dataset.variantId,
      handle: element.dataset.handle,
      title: element.dataset.title,
      url: element.dataset.url,
      image: element.dataset.image,
      price: element.dataset.price,
      currency: element.dataset.currency || 'EUR'
    };
  }

  function isSelected(productId) {
    return getProducts().some(
      product =>
        String(product.id) === String(productId)
    );
  }

  function updateButton() {
    const wrapper = document.querySelector(
      '[data-mr-compare-product]'
    );

    if (!wrapper) return;

    const button = wrapper.querySelector(
      '.mr-compare-button'
    );

    const text = wrapper.querySelector(
      '.mr-compare-button__text'
    );

    if (!button || !text) return;

    const selected = isSelected(
      wrapper.dataset.productId
    );

    button.classList.toggle(
      'is-selected',
      selected
    );

    button.setAttribute(
      'aria-pressed',
      selected ? 'true' : 'false'
    );

    text.textContent = selected
      ? 'Im Vergleich'
      : 'Zum Vergleich hinzufügen';
  }

  function updateFloatingButton() {
    const floating = document.getElementById(
      'MrCompareFloating'
    );

    if (!floating) return;

    const products = getProducts();

    const count = floating.querySelector(
      '[data-mr-compare-floating-count]'
    );

    if (!products.length) {
      floating.hidden = true;
      return;
    }

    floating.hidden = false;

    if (count) {
      count.textContent = products.length;
    }
  }

  function renderBar(open = false) {
    const bar = document.getElementById(
      'MrCompareBar'
    );

    if (!bar) return;

    const products = getProducts();

    const container = bar.querySelector(
      '[data-mr-compare-products]'
    );

    const count = bar.querySelector(
      '.mr-compare-bar__count'
    );

    const goButton = bar.querySelector(
      '[data-mr-compare-go]'
    );

    updateFloatingButton();
    updateButton();

    if (!products.length) {
      bar.classList.remove('is-open');
      bar.hidden = true;
      return;
    }

    bar.hidden = false;

    if (count) {
      count.textContent =
        `${products.length} von ${MAX_PRODUCTS} ausgewählt`;
    }

    if (container) {
      container.innerHTML = '';

      products.forEach(product => {
        const item = document.createElement('div');

        item.className =
          'mr-compare-bar__product';

        const image = product.image
          ? `
            <img
              src="${escapeHtml(product.image)}"
              alt=""
            >
          `
          : '';

        item.innerHTML = `
          <div class="mr-compare-bar__image">
            ${image}

            <button
              type="button"
              class="mr-compare-bar__remove"
              data-remove-product="${escapeHtml(
                String(product.id)
              )}"
              aria-label="Radsatz entfernen"
            >
              ×
            </button>
          </div>

          <div class="mr-compare-bar__product-info">
            <span class="mr-compare-bar__product-title">
              ${escapeHtml(product.title)}
            </span>

            <strong class="mr-compare-bar__product-price">
              ${formatPrice(
                product.price,
                product.currency
              )}
            </strong>
          </div>
        `;

        container.appendChild(item);
      });

      for (
        let i = products.length;
        i < MAX_PRODUCTS;
        i += 1
      ) {
        const empty =
          document.createElement('div');

        empty.className =
          'mr-compare-bar__product mr-compare-bar__product--empty';

        empty.innerHTML = `
          <div class="mr-compare-bar__empty-plus">
            +
          </div>

          <span>Radsatz hinzufügen</span>
        `;

        container.appendChild(empty);
      }
    }

    if (goButton) {
      goButton.disabled =
        products.length < 2;
    }

    if (open) {
      requestAnimationFrame(() => {
        bar.classList.add('is-open');
      });
    }
  }

  function openBar() {
    const products = getProducts();

    if (!products.length) return;

    renderBar(true);
  }

  function closeBar() {
    const bar = document.getElementById(
      'MrCompareBar'
    );

    if (!bar) return;

    bar.classList.remove('is-open');
  }

  function addCurrentProduct() {
    const current = getCurrentProduct();

    if (!current) return;

    const products = getProducts();

    const alreadySelected = products.some(
      product =>
        String(product.id) ===
        String(current.id)
    );

    if (alreadySelected) {
      openBar();
      return;
    }

    if (products.length >= MAX_PRODUCTS) {
      openBar();
      return;
    }

    products.push(current);

    saveProducts(products);

    updateButton();
    updateFloatingButton();
    renderBar(true);
  }

  function removeProduct(productId) {
    const products = getProducts().filter(
      product =>
        String(product.id) !==
        String(productId)
    );

    if (products.length) {
      saveProducts(products);
    } else {
      localStorage.removeItem(STORAGE_KEY);
    }

    updateButton();
    updateFloatingButton();

    if (!products.length) {
      const bar = document.getElementById(
        'MrCompareBar'
      );

      if (bar) {
        bar.classList.remove('is-open');
        bar.hidden = true;
      }

      return;
    }

    renderBar(true);
  }

  function clearProducts() {
    localStorage.removeItem(STORAGE_KEY);

    const bar = document.getElementById(
      'MrCompareBar'
    );

    if (bar) {
      bar.classList.remove('is-open');
      bar.hidden = true;
    }

    updateButton();
    updateFloatingButton();
  }

  function escapeHtml(value) {
    return String(value ?? '')
      .replaceAll('&', '&amp;')
      .replaceAll('<', '&lt;')
      .replaceAll('>', '&gt;')
      .replaceAll('"', '&quot;')
      .replaceAll("'", '&#039;');
  }

  document.addEventListener('click', event => {
    const compareButton = event.target.closest(
      '.mr-compare-button'
    );

    if (compareButton) {
      addCurrentProduct();
      return;
    }

    if (
      event.target.closest(
        '[data-mr-compare-open]'
      )
    ) {
      openBar();
      return;
    }

    const removeButton = event.target.closest(
      '[data-remove-product]'
    );

    if (removeButton) {
      removeProduct(
        removeButton.dataset.removeProduct
      );
      return;
    }

    if (
      event.target.closest(
        '[data-mr-compare-close]'
      )
    ) {
      closeBar();
      return;
    }

    if (
      event.target.closest(
        '[data-mr-compare-clear]'
      )
    ) {
      clearProducts();
      return;
    }

    if (
      event.target.closest(
        '[data-mr-compare-go]'
      )
    ) {
      window.location.href = '/pages/vergleich';
    }
  });

  function initCompare() {
    updateButton();
    updateFloatingButton();
    renderBar(false);
  }

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      initCompare
    );
  } else {
    initCompare();
  }
})();